<template>
	<v-autocomplete
		:items="items"
		:label="label"
		:disabled="disabled"
		:multiple="multiple"
		:value="selected"
		:clearable="clearable"
		:error-count="3"
		:error-messages="errors || []"
		autocomplete="new-password"
		item-text="name"
		item-value="abbreviation"
		@input="onInput($event)"
		@change="onChange($event)"
	/>
</template>

<script>
import states from '@/datasources/states'

export default {
	props: {
		errors: {
			type: Array,
			default: () => [],
		},
		country: String,
		disabled: Boolean,
		label: String,
		value: [String, Array],
		clearable: Boolean,
		multiple: Boolean,
	},
	computed: {
		selected() {
			return this.value
		},
		items() {
			return states[this.country] || []
		},
	},
	methods: {
		onInput(event) {
			this.$emit('input', event)
		},
		onChange(event) {
			this.$emit('change', event)
		},
	},
}
</script>
